module.exports = __webpack_public_path__ + "img/5g.2f5ecde2.jpeg";